import type { InquiryItem } from '@/types/api';

import { LayoutReviewsContent } from '../../_layouts/LayoutsReviewsContent';
import LeftContentSection from './LeftContentSection';
import RightContentSection from './RightContentSection';

const InquiryContent = ({ inquiry }: { inquiry: InquiryItem }) => {
  return (
    <LayoutReviewsContent>
      <LeftContentSection inquiry={inquiry} />
      {/* Right Section */}
      <RightContentSection inquiry={inquiry} />
    </LayoutReviewsContent>
  );
};

export default InquiryContent;
